module.exports = __webpack_public_path__ + "media/icons/arrow-right-687b694c.svg";